<div id="contenedor">
  <div *ngIf="!loading" class="logo">
    <img [src]="logo" />
  </div>
  <div
    *ngIf="!loading && block"
    style="height: 600px"
    class="content"
    (click)="unBlock()"
  >
    <div
      *ngIf="block"
      (click)="unBlock()"
      style="height: 600px"
      class="orientation-container texto"
    >
      {{ orientation.BlockMessage }}
    </div>
  </div>
  <div *ngIf="!loading && !block" class="content">
    <div class="orientation-container">
      <div
        *ngIf="document && medicalAppointmentIds.length === 0"
        [@simpleFadeAnimation]
        class="texto"
      >
        Por favor, ingrese su Número de Documento o escanee el código QR
      </div>

      <mat-card
        *ngIf="medicalAppointmentIds.length > 0"
        [@simpleFadeAnimation]
        class="orientation"
      >
        <mat-card-content>
          <p>
            <app-orientation-appointment-list
              [loadingAction]="loadingAction"
              (finalizedWidthAdmission)="generateAppointmentAdmission()"
              (finalizedWidthOutAdmission)="printAdmission()"
              [medicalAppointmentIds]="medicalAppointmentIds"
            >
            </app-orientation-appointment-list></p
        ></mat-card-content>
      </mat-card>

      <mat-card
        *ngIf="document && medicalAppointmentIds.length === 0"
        [@simpleFadeAnimation]
        class="orientation"
      >
        <mat-card-content>
          <p>
            <mat-form-field style="width: 50%">
              <input
                [hidden]="qrIsHidden"
                type="text"
                #qrInput
                [(ngModel)]="qrCode"
                matInput
                (window:keypress)="onKey($event)"
                autofocus
              />
              <input
                type="number"
                [(ngModel)]="patientDocument"
                autocomplete="off"
                class="document-text"
                matInput
              />
            </mat-form-field>
          </p>
          <p>
            <button
              class="action-button-panel"
              (click)="setDisabilityTemporal()"
              *ngIf="!disabilityTemporal"
              mat-button
              color="primary"
            >
              <mat-icon>accessible</mat-icon> Discapacidad
            </button>
            <button
              class="action-button-panel"
              (click)="setDisabilityTemporal()"
              *ngIf="disabilityTemporal"
              mat-button
              color="accent"
            >
              <mat-icon>accessible</mat-icon> Discapacidad
            </button>
          </p>
          <p>
            <button
              mat-fab
              class="document-button"
              (click)="setNumber('7')"
              color="primary"
            >
              7
            </button>
            <button
              mat-fab
              class="document-button"
              (click)="setNumber('8')"
              color="primary"
            >
              8
            </button>
            <button
              mat-fab
              class="document-button"
              (click)="setNumber('9')"
              color="primary"
            >
              9
            </button>
          </p>
          <p>
            <button
              mat-fab
              class="document-button"
              (click)="setNumber('4')"
              color="primary"
            >
              4
            </button>
            <button
              mat-fab
              class="document-button"
              (click)="setNumber('5')"
              color="primary"
            >
              5
            </button>
            <button
              mat-fab
              class="document-button"
              (click)="setNumber('6')"
              color="primary"
            >
              6
            </button>
          </p>
          <p>
            <button
              mat-fab
              class="document-button"
              (click)="setNumber('1')"
              color="primary"
            >
              1
            </button>
            <button
              mat-fab
              class="document-button"
              (click)="setNumber('2')"
              color="primary"
            >
              2
            </button>
            <button
              mat-fab
              class="document-button"
              (click)="setNumber('3')"
              color="primary"
            >
              3
            </button>
          </p>
          <p>
            <button
              mat-fab
              class="document-button"
              (click)="setNumber('0')"
              color="primary"
            >
              0
            </button>
          </p>
          <p>
            <button
              mat-button
              class="action-button-panel"
              (click)="clear()"
              color="primary"
            >
              Borrar
            </button>
          </p>

          <p style="text-align: right; margin-right: 5px">
            <mat-spinner *ngIf="loadingAction"></mat-spinner>
            <button
              class="next-button"
              *ngIf="!loadingAction"
              mat-stroked-button
              (click)="documentNext()"
              color="primary"
            >
              Siguiente
            </button>
          </p>
        </mat-card-content>
      </mat-card>

      <div *ngIf="birthDate" [@simpleFadeAnimation] class="texto">
        Ahora, ingrese su Fecha de Nacimiento
      </div>
      <mat-card *ngIf="birthDate" [@simpleFadeAnimation] class="orientation">
        <mat-card-content>
          <mat-form-field style="margin-right: 10px">
            <mat-label class="texto">Día</mat-label>
            <mat-select
              style="margin-top: 15px"
              class="texto"
              [(ngModel)]="selectedDayValue"
              name="day"
            >
              <mat-option *ngFor="let date of dates" [value]="date">
                {{ date }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field style="width: 400px; margin-right: 10px">
            <mat-label class="texto">Mes</mat-label>
            <mat-select
              style="margin-top: 15px"
              class="texto"
              [(ngModel)]="selectedMonthValue"
              name="month"
            >
              <mat-option *ngFor="let month of months" [value]="month.value">
                {{ month.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <mat-label class="texto">Año</mat-label>
            <mat-select
              style="margin-top: 15px"
              class="texto"
              [(ngModel)]="selectedYearValue"
              name="year"
            >
              <mat-option *ngFor="let year of years" [value]="year">
                {{ year }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <p style="text-align: right; margin-right: 5px">
            <button
              class="next-button"
              mat-stroked-button
              (click)="birthDateBack()"
              color="primary"
            >
              Anterior
            </button>
            <button
              class="next-button"
              mat-stroked-button
              (click)="birthDateNext()"
              color="primary"
            >
              Siguiente
            </button>
          </p>
        </mat-card-content>
      </mat-card>

      <div
        *ngIf="action && getPatientName()"
        [@simpleFadeAnimation]
        class="texto"
      >
        Bienvenido <b> {{ getPatientName() }} </b>
      </div>
      <div *ngIf="action" [@simpleFadeAnimation] class="texto">
        {{ orientation.ActionMessage }}
      </div>
      <mat-card *ngIf="action" [@simpleFadeAnimation] class="orientation">
        <mat-card-content>
          <mat-spinner *ngIf="loadingAction"></mat-spinner>
          <button
            *ngIf="!loadingAction && orientation.AdmissionEnabled"
            class="action-button"
            (click)="printAdmission()"
            mat-stroked-button
            color="primary"
          >
            Recepción para atención médica
          </button>
          <button
            *ngIf="!loadingAction && orientation.AdmissionEnabled"
            class="action-button"
            (click)="printReservation()"
            mat-stroked-button
            color="primary"
          >
            Solicitar reserva de turno
          </button>
          <button
            *ngIf="!loadingAction && orientation.DeliveryEnabled"
            class="action-button"
            (click)="printDelivery()"
            mat-stroked-button
            color="primary"
          >
            Retiro de estudios
          </button>
          <p
            *ngIf="!loadingAction"
            style="text-align: right; margin-right: 5px"
          >
            <button
              class="next-button"
              mat-stroked-button
              (click)="cancel()"
              color="primary"
            >
              Finalizar
            </button>
          </p>
        </mat-card-content>
      </mat-card>

      <div *ngIf="service" [@simpleFadeAnimation] class="texto">
        Por favor, seleccione un servicio
      </div>
      <mat-card *ngIf="service" [@simpleFadeAnimation] class="orientation">
        <mat-card-content>
          <mat-spinner *ngIf="loadingAction"></mat-spinner>
          <div *ngIf="!loadingAction">
            <button
              *ngFor="let service of orientation.Services"
              class="action-button"
              (click)="serviceNext(service)"
              mat-stroked-button
              color="primary"
            >
              {{ service.Name }}
            </button>
          </div>
          <p style="text-align: right; margin-right: 5px">
            <button
              class="next-button"
              mat-stroked-button
              (click)="serviceBack()"
              color="primary"
            >
              Anterior
            </button>
          </p>
        </mat-card-content>
      </mat-card>

      <div
        (click)="cancel()"
        *ngIf="otherReservation"
        [@simpleFadeAnimation]
        class="texto"
      >
        Recuerde que usted tiene otras reservas en...
      </div>
      <mat-card
        (click)="cancel()"
        *ngIf="otherReservation"
        [@simpleFadeAnimation]
        class="orientation"
      >
        <mat-card-content>
          <p
            class="otherReservation-text"
            *ngFor="let otherReservationText of otherReservationsText"
          >
            {{ otherReservationText }}
          </p>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
